var _a;
export const setCookie = (name, value, exdays, domain = '', path = '/') => {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    const cookie = `${name}=${value};${expires};${domain !== '' ? `domain=${domain};` : ''}path=${path}`;
    document.cookie = cookie;
};
export const getCookie = (cname) => {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};
const devEnvironments = ['dev', 'development'];
const env = typeof process !== 'undefined' ? ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) || '' : '';
export const getCookieDomain = () => devEnvironments.includes(env) ? 'localhost' : 'turing.com';
//# sourceMappingURL=cookie.js.map